<template>
  <div class="map-controls__wrapper">
    <v-btn fab small color="white" class="zoom-in__btn btn" @click="zoomIn" :disabled="currentZoom >= maxZoom">
      <v-icon color="primary">mdi-magnify-plus</v-icon>
    </v-btn>
    <span class="zoom-factor">{{ zoom }}</span>
    <v-btn fab small color="white" class="zoom-out__btn btn" @click="zoomOut" :disabled="currentZoom <= minZoom">
      <v-icon color="primary">mdi-magnify-minus</v-icon>
    </v-btn>
    <v-btn fab small color="white" class="go-home__btn btn" @click="resetMap">
      <v-icon color="primary">mdi-home</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MapControlls',
  computed: {
    ...mapGetters('mapStore', ['zoom', 'minZoom', 'maxZoom', 'currentZoom'])
  },
  methods: {
    ...mapActions('mapStore', ['zoomIn', 'zoomOut', 'resetMap'])
  }
};
</script>

<style lang="scss" scoped>
.map-controls__wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 24px;
  left: 25px;

  .btn {
    border: 1px solid;
    border-color: var(--v-primary-base) !important;
    box-shadow: none;
    width: 40px;
  }

  .zoom-in__btn {
    border-radius: 50% 0 0 0;
  }

  .zoom-out__btn {
    border-radius: 0 0 0 50%;
  }

  .go-home__btn {
    position: absolute;
    height: 100%;
    top: 50%;
    right: 0;
    transform: translate(100%, -50%);
    border-radius: 0 50% 50% 0;
  }

  .zoom-factor {
    color: var(--v-primary-base);
    background: white;
    border: 1px solid;
    border-color: var(--v-primary-base);
    text-align: center;
    width: 40px;
    font-weight: 700;
    user-select: none;
  }
}
</style>

<style lang="scss">
.map-controls__wrapper {
  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background: rgba(0, 0, 0, 0.5) !important;
  }

  .theme--light.v-btn.v-btn--disabled .v-icon {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  .theme--light.v-btn:focus::before {
    opacity: 0;
  }
}
</style>
